<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.user.dialog.title' | translate: { user: viewModel.bo?.model?.firstName + ' ' + viewModel.bo?.model?.lastName }"
		id="user-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div [sklValidationSource]="viewValidation">
					<ins-form-field
						[label]="'scenes.configuration.shared.user.dialog.form.role.label' | translate">
						<ins-select
							display-text="name"
							id="user-dialog-role"
							[sklValidate]="getValidationKey('roleId')"
							[converter]="viewModel.rolesConverter"
							[(ngModel)]="viewModel.role.value">
							@for (item of viewModel.roles; track item) {
								<ins-option
									[value]="item">
									{{item.name}}
								</ins-option>
							}
						</ins-select>
					</ins-form-field>
					<div class="align--small">
						<div class="label">{{'scenes.configuration.shared.user.dialog.form.permissions.label' | translate}}</div>
						<skl-panel-wrapper>
							@for (group of viewModel.permissionGroups; track group) {
								<skl-panel
									[id]="'user-dialog-permission-group-' + group.label"
									[isOpen]="true"
									[headerVisible]="true"
									[headerText]="group.label">
									<div class="permission-wrapper">
										@for (permission of group.permissions; track permission) {
											<div class="permission">
												<div class="permission--checkbox">
													<ins-checkbox
														[id]="'user-dialog-permission-checkbox-' + permission.kind"
														[ngModel]="permission.selected"
														(ngModelChange)="viewModel.switchPermission($event, permission)"
														[sklValidate]="getValidationKey('userPermissionKinds')">
													</ins-checkbox>
												</div>
												<div>
													<div>{{permission.label}}</div>
													<div class="permission--description-" [id]="'user-dialog-permission-description-' + permission.kind">{{permission.description}}</div>
												</div>
											</div>
										}
									</div>
								</skl-panel>
							}
						</skl-panel-wrapper>
					</div>
				</div>
			}
		</skl-form-container>

	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="user-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			id="user-dialog-save-button"
			typeName="accent"
			[spinner]="viewModel.isSaving"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>
